import { listAssets, createProjectAsset, updateProjectAsset, deleteProjectAsset, listUploads } from '@/api/workflow';

export default {
  namespaced: true,
  state: () => ({
    uploads: {
      loading: false,
      uploading: false,
      error: null,
      items: [],
      projectId: null
    },
    assets: {
      loading: false,
      uploading: false,
      error: null,
      items: [],
      projectId: null
    }
  }),
  mutations: {
    fetchCurrentProjectUploadsPending(state) {
      state.uploads.loading = true;
      state.uploads.error = null;
      state.uploads.items = [];
      state.uploads.projectId = null;
    },
    fetchCurrentProjectUploadsSuccess(state, { uploads, projectId }) {
      state.uploads.loading = false;
      state.uploads.error = null;
      state.uploads.items = uploads;
      state.uploads.projectId = projectId;
    },
    fetchCurrentProjectUploadsFailure(state, error) {
      state.uploads.loading = false;
      state.uploads.error = error;
    },
    fetchCurrentProjectAssetsPending(state) {
      state.assets.loading = true;
      state.assets.error = null;
      state.assets.items = [];
      state.assets.projectId = null;
    },
    fetchCurrentProjectAssetsSuccess(state, { assets, projectId }) {
      state.assets.loading = false;
      state.assets.error = null;
      state.assets.items = assets;
      state.assets.projectId = projectId;
    },
    fetchCurrentProjectAssetsFailure(state, error) {
      state.assets.loading = false;
      state.assets.error = error;
    },
    setAssetsError(state, error) {
      state.assets.error = error;
    },
    addAsset(state, asset) {
      state.assets.items = [...state.assets.items, asset];
    },
    setAsset(state, asset) {
      state.assets.items = state.assets.items.map(item => {
        if (item.id === asset.id) {
          return asset;
        }
        return item;
      });
    },
    removeAsset(state, asset) {
      state.assets.items = state.assets.items.filter(item => item.id !== asset.id);
    }
  },
  actions: {
    async fetchCurrentProjectUploads({ commit, state, rootState }) {
      if (state.assets.projectId === rootState.workflow.currentProjectId) {
        return;
      }
      commit('fetchCurrentProjectUploadsPending');
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
        };
        const uploads = await listUploads(payload);
        commit('fetchCurrentProjectUploadsSuccess', { uploads, projectId: payload.projectId });
      } catch (err) {
        console.error('Server error when getting uploads', err);
        commit('fetchCurrentProjectUploadsFailure', 'Error when getting uploads');
      }
    },
    async fetchCurrentProjectAssets({ commit, state, rootState }) {
      if (state.assets.projectId === rootState.workflow.currentProjectId) {
        return;
      }
      commit('fetchCurrentProjectAssetsPending');
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          filters: {
            groups: ['campaign-assets', 'brand-identity']
          }
        };
        const assets = await listAssets(payload);
        commit('fetchCurrentProjectAssetsSuccess', { assets, projectId: payload.projectId });
      } catch (err) {
        console.error('Server error when getting assets', err);
        commit('fetchCurrentProjectAssetsFailure', 'Error when getting assets');
      }
    },
    async addCurrentProjectAsset({ commit, rootState }, { asset }) {
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          ...asset,
          fileId: asset.fileId || asset?.resumableFile?.uniqueIdentifier
        };
        const result = await createProjectAsset(payload);
        commit('addAsset', result);
        return result;
      } catch (err) {
        console.error(`Server error when adding asset`, err);
        throw err;
      }
    },
    async updateCurrentProjectAsset({ commit, state, rootState }, { asset }) {
      const previousValue = state.assets.items.find(item => item.id === asset.id);
      commit('setAsset', asset);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          assetId: asset.id,
          ...asset
        };
        await updateProjectAsset(payload);
      } catch (err) {
        console.error(`Server error when updating asset`, err);
        commit('setAsset', previousValue);
        commit('setAssetsError', 'Error when updating asset');
      }
    },
    async removeCurrentProjectAsset({ commit, rootState }, { asset }) {
      commit('removeAsset', asset);
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          assetId: asset.id
        };
        await deleteProjectAsset(payload);
      } catch (err) {
        console.error(`Server error when removing asset`, err);
        commit('setAssetsError', 'Error when removing asset');
      }
    }
  }
};
